import React, {Component} from 'react'

class Price extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <div className={`price ${this.props.compareAtPrice && parseFloat(this.props.compareAtPrice.amount) > parseFloat(this.props.price.amount) ? 'price--on-sale' : ''}`} >
        <dl>
          <div className="price__regular">
            <dt>
              <span className="visually-hidden visually-hidden--inline">Regular price</span>
            </dt>
            <dd>
              {
                this.props.lookbook && location.search.includes('sort_by=price-') && this.props.priceRange.minVariantPrice.amount < this.props.priceRange.maxVariantPrice.amount ?
                <span className="price-item price-item--regular">
                  ${(this.props.multiply ? parseFloat(this.props.priceRange.minVariantPrice.amount) * this.props.multiply : parseFloat(this.props.priceRange.minVariantPrice.amount)).toFixed(2)}
                  to
                  ${(this.props.multiply ? parseFloat(this.props.priceRange.maxVariantPrice.amount) * this.props.multiply : parseFloat(this.props.priceRange.maxVariantPrice.amount)).toFixed(2)}
                </span> :
                <span className="price-item price-item--regular">${(this.props.multiply ? parseFloat(this.props.price.amount) * this.props.multiply : parseFloat(this.props.price.amount)).toFixed(2)}</span>
              }
            </dd>
          </div>
          {
            !this.props.lookbook &&
            <div className="price__sale">
              <dt className="price__compare">
                <span className="visually-hidden visually-hidden--inline">Regular price</span>
              </dt>
              <dd className="price__compare">
                <s className="price-item price-item--regular">${this.props.compareAtPrice && (this.props.multiply ? parseFloat(this.props.compareAtPrice.amount) * this.props.multiply : parseFloat(this.props.compareAtPrice.amount)).toFixed(2)}</s>
              </dd>
              <dt>
                <span className="visually-hidden visually-hidden--inline">Sale price</span>
              </dt>
              <dd>
                <span className="price-item price-item--sale">${(this.props.multiply ? parseFloat(this.props.price.amount) * this.props.multiply : parseFloat(this.props.price.amount)).toFixed(2)}</span>
              </dd>
            </div>
          }
        </dl>
      </div>
    )
  }
}

export default Price